import { httpError } from 'store/httpError.js'
import * as util from 'lib/util.js'

export default {
    getComments(context, payload){
        PubSub.publish("requestout",null);
        var formParams = []
        formParams.push('kbrid=' + payload);
        formParams.push('versionid=-1');
        fetch(context.state.kb_rest_server + "/kb/jrest/getComments", {
            method: 'post',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: formParams.join("&")
        }) 
        .then(function(response) {
            if (!response.ok) {
                httpError(response, context);
                throw Error();  //to bail out of promise chain
            }
            return response;
        }.bind(this))
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            context.commit("setState", {property:  "topic_comments" ,  value: data.comments });
        })
        .catch(function(error) {
            })
        .finally(function(){
                PubSub.publish("requestin",null);
            });
    },
    addComment(context, payload){
        PubSub.publish("requestout",null);
        var kbrid = payload.kbrid;
        var formParams = []
        formParams.push('kbrid=' + payload.kbrid);
        formParams.push('weburi=' + encodeURIComponent(payload.weburi));
        formParams.push('text=' + encodeURIComponent(payload.text));

        fetch(context.state.kb_rest_server + "/kb/jrest/addComment", {
            method: 'post',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: formParams.join("&")
        }) 
        .then(function(response) {
            if (!response.ok) {
                httpError(response, context);
                throw Error();  //to bail out of promise chain
            }
            return response;
        }.bind(this))
        .then((response) => {
            PubSub.publish("commentsaved",null);
            context.dispatch("getComments", kbrid)
        })
        .then((data) => {
            
            })
        .catch(function(error) {
            })
        .finally(function(){
                PubSub.publish("requestin",null);
            });
    },
    deleteComment(context, payload){
        PubSub.publish("requestout",null);
        var kbrid = payload.kbrid;
        var formParams = []
        formParams.push('commentid=' + payload.commentid);
        fetch(context.state.kb_rest_server + "/kb/jrest/deleteComment", {
            method: 'post',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: formParams.join("&")
        }) 
        .then(function(response) {
            if (!response.ok) {
                httpError(response, context);
                throw Error();  //to bail out of promise chain
            }
            return response;
        }.bind(this))
        .then((response) => {
            PubSub.publish("commentdeleted",null);
            context.dispatch("getComments", kbrid)
        })
        .then((data) => {
            })
        .catch(function(error) {
            })
        .finally(function(){
                PubSub.publish("requestin",null);
            });
    },
    updateComment(context, payload){
        PubSub.publish("requestout",null);
        var kbrid = payload.kbrid;
        var formParams = []
        formParams.push('commentid=' + payload.commentid);
        formParams.push('text=' + payload.text);
        fetch(context.state.kb_rest_server + "/kb/jrest/updateComment", {
            method: 'post',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: formParams.join("&")
        }) 
        .then(function(response) {
            if (!response.ok) {
                httpError(response, context);
                throw Error();  //to bail out of promise chain
            }
            return response;
        }.bind(this))
        .then((response) => {
            PubSub.publish("commentupdated",null);
        })
        .then((data) => {
            })
        .catch(function(error) {
            })
        .finally(function(){
                PubSub.publish("requestin",null);
            });
    },
};




